<div class="life-cross" [class.mirrored]="isMirrored()">
  @if (showTransformationArrow()) {
    <hd-transformation-arrow
      class="transformation-arrow-slot"
      [tone]="viewTone()!"
      [side]="side()"
      [category]="phsCategory()"
      [colorConfig]="colorConfig()"
      [showHdKeynotes]="showHdKeynotes()"
      [relatedGates]="furnishingGates()"
      (phsBlockClicked)="onPhsBlockClicked($event)"
    ></hd-transformation-arrow>
  }

  @if (southNodeBlock(); as sn) {
    <hd-planet-activation-block
      class="south-node-block"
      [activation]="sn.activation"
      [displayConfig]="sn.displayConfig"
      [colorConfig]="colorConfig()"
      [isDefined]="sn.isDefined"
      [showHdKeynotes]="showHdKeynotes()"
      [nodeLinkMatchGates]="southNodeLinkMatchGates()"
      [baseHoverTargetGate]="southNodeBaseHoverGate()"
      [density]="density()"
      variant="cross"
      (blockClicked)="blockClicked.emit($event)"
    ></hd-planet-activation-block>
  }

  @if (northNodeBlock(); as nn) {
    <hd-planet-activation-block
      class="north-node-block"
      [activation]="nn.activation"
      [displayConfig]="nn.displayConfig"
      [colorConfig]="colorConfig()"
      [isDefined]="nn.isDefined"
      [showHdKeynotes]="showHdKeynotes()"
      [nodeLinkMatchGates]="northNodeLinkMatchGates()"
      [baseHoverTargetGate]="northNodeBaseHoverGate()"
      [density]="density()"
      variant="cross"
      (blockClicked)="blockClicked.emit($event)"
    ></hd-planet-activation-block>
  }

  @if (viewColor() !== null && viewTone() !== null) {
    <hd-color-tone-block
      class="view-block"
      [colorNumber]="viewColor()!"
      [toneNumber]="viewTone()!"
      [side]="side()"
      [colorConfig]="colorConfig()"
      [colorIcon]="phsColorIcon()"
      [cognitionIcon]="phsCognitionIcon()"
      [colorTooltip]="phsColorTooltip()"
      [cognitionTooltip]="phsCognitionTooltip()"
      [variantIcon]="phsVariantIcon()"
      [variantTooltip]="phsVariantTooltip()"
      [mode]="visualizationMode()"
      [density]="density()"
      [variantName]="phsVariantName()"
      [cognitionName]="phsCognitionName()"
      [relatedGates]="furnishingGates()"
      (phsBlockClicked)="onPhsBlockClicked($event)"
    ></hd-color-tone-block>
  }
</div>
